import styled from 'styled-components';

export const ConsultsPackageInProgress = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  justify-content: center;
  gap: 12px;
  align-items: center;
  font-size: 12px;

  .progress-bar-container {
    width: 100%;
    max-width: 250px;
    min-width: 150px;
    justify-self: start;
  }

  span {
    width: fit-content;
    justify-self: end;
  }
`;



